import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_org/org/providers/pools/$id/")({
  beforeLoad: ({ context, params }) => {
    const organizationBusinessUnitId = (
      context as { savedOrgBusinessUnit?: { id?: string } }
    ).savedOrgBusinessUnit?.id;
    if (!organizationBusinessUnitId) {
      throw redirect({ to: "/org/providers" });
    }
    throw redirect({
      to: "/org/bu/$organizationBusinessUnitId/providers/pools/$id",
      params: { organizationBusinessUnitId, id: (params as { id: string }).id },
    });
  },
});
